module.exports = __webpack_public_path__ + "images/inqar7324b51b5e8fbdcc7fccbc6fe39c08dd.png";